// ============================================================================
// helyMentes.js — az utolsó hely és a félbehagyott szöveg megőrzése ÚJRATÖLTÉS után (2026-10-18, tagi jelzés / AI-titkári audit:
// "újratöltés után a szoba listájára ugrik, és az elkezdett szöveg eltűnik"; iPhone-on a lehúzás újratölt).
//
// Mit ment (a böngésző localStorage-ában, ezen az eszközön):
//   - a FÉLBEHAGYOTT SZÖVEGET szobánként ÉS témánként (a kulcsban a felhasználó azonosítója is van: másik tag nem látja);
//   - az UTOLSÓ HELYET (szoba + téma), hogy az újratöltés ugyanoda vigyen vissza.
// Nem ment: képet, fájlt, a küldés állapotát (azok nagyok / nem újratöltés-állók), és semmit az URL-be (nem kerül szöveg a címsorba).
//
// Védelem: a szöveg 30 nap után lejár, legfeljebb 50 000 karakter; kijelentkezéskor mindkettő törlődik (közös eszköz);
// minden tárolás-hiba (privát ablak, tele, tiltott tároló) csendben marad: ilyenkor nincs megőrzés, de nincs hiba sem.
// A tároló (localStorage) paraméter: a tesztben hamis tároló adható.
// ============================================================================

const ELO_PISZKOZAT = "lineage0_draft:";
const ELO_HELY = "lineage0_place:";
export const PISZKOZAT_ELETTARTAM_MS = 30 * 24 * 60 * 60 * 1000;
export const PISZKOZAT_MAX_KARAKTER = 50000;

const jo = (x) => typeof x === "string" && x !== "" && !x.includes(":");
const kulcs = (uid, roomId, topicId) => `${ELO_PISZKOZAT}${uid}:${roomId}:${topicId || "-"}`;

/**
 * @returns {boolean} true, ha a művelet a tárolóra vonatkozóan rendben lezajlott (az üres szöveg törlése is);
 *   false, ha nincs tároló / hibás azonosító / tárolási hiba.
 */
export function piszkozatMentese(tar, uid, roomId, topicId, szoveg, most = Date.now()) {
  if (!tar || !jo(uid) || !jo(roomId) || (topicId && !jo(topicId))) return false;
  try {
    const k = kulcs(uid, roomId, topicId);
    const s = typeof szoveg === "string" ? szoveg : "";
    if (s.trim() === "") {
      tar.removeItem(k);
      return true;
    }
    tar.setItem(k, JSON.stringify({ t: s.slice(0, PISZKOZAT_MAX_KARAKTER), at: most }));
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * @returns {string|null} a mentett szöveg ("" ha nincs / lejárt); null, ha a tároló nem használható (ilyenkor a hívó
 *   a régi, memóriabeli viselkedésnél marad).
 */
export function piszkozatBetoltese(tar, uid, roomId, topicId, most = Date.now()) {
  if (!tar || !jo(uid) || !jo(roomId) || (topicId && !jo(topicId))) return null;
  try {
    const k = kulcs(uid, roomId, topicId);
    const nyers = tar.getItem(k);
    if (!nyers) return "";
    const d = JSON.parse(nyers);
    if (!d || typeof d.t !== "string" || typeof d.at !== "number" || most - d.at > PISZKOZAT_ELETTARTAM_MS) {
      tar.removeItem(k);
      return "";
    }
    return d.t;
  } catch (e) {
    return null;
  }
}

/** Egy felhasználó MINDEN mentett szövege és helye törlődik (kijelentkezéskor). */
export function mindenTorlese(tar, uid) {
  if (!tar || !jo(uid)) return;
  try {
    const torlendo = [];
    for (let i = 0; i < tar.length; i++) {
      const k = tar.key(i);
      if (k && (k.startsWith(`${ELO_PISZKOZAT}${uid}:`) || k === `${ELO_HELY}${uid}`)) torlendo.push(k);
    }
    for (const k of torlendo) tar.removeItem(k);
  } catch (e) {
    // nem kritikus
  }
}

export function helyMentese(tar, uid, roomId, topicId) {
  if (!tar || !jo(uid) || !jo(roomId) || (topicId && !jo(topicId))) return false;
  try {
    tar.setItem(`${ELO_HELY}${uid}`, JSON.stringify({ roomId, topicId: topicId || null }));
    return true;
  } catch (e) {
    return false;
  }
}

/** @returns {{roomId: string, topicId: string|null}|null} */
export function helyBetoltese(tar, uid) {
  if (!tar || !jo(uid)) return null;
  try {
    const d = JSON.parse(tar.getItem(`${ELO_HELY}${uid}`) || "null");
    if (!d || !jo(d.roomId) || (d.topicId !== null && !jo(d.topicId))) return null;
    return { roomId: d.roomId, topicId: d.topicId || null };
  } catch (e) {
    return null;
  }
}

/** Hány nem elküldött szöveg (piszkozat) van elmentve ezen az eszközön, MINDEN felhasználóé együtt (közös eszközre váltás előtti figyelmeztetéshez). */
export function piszkozatokSzama(tar) {
  if (!tar) return 0;
  try {
    let n = 0;
    for (let i = 0; i < tar.length; i++) {
      const k = tar.key(i);
      if (k && k.startsWith(ELO_PISZKOZAT)) n++;
    }
    return n;
  } catch (e) {
    return 0;
  }
}

/** MINDEN felhasználó mentett szövege és helye törlődik az eszközről (közös eszközre váltáskor, a felhasználó jóváhagyásával). */
export function mindenFelhasznaloTorlese(tar) {
  if (!tar) return;
  try {
    const torlendo = [];
    for (let i = 0; i < tar.length; i++) {
      const k = tar.key(i);
      if (k && (k.startsWith(ELO_PISZKOZAT) || k.startsWith(ELO_HELY))) torlendo.push(k);
    }
    for (const k of torlendo) tar.removeItem(k);
  } catch (e) {
    // nem kritikus
  }
}
